module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-radio-button', _vm._b({}, 'el-radio-button', _vm.$attrs, false), [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a1fc19c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/radio/rtRadioButton.vue
// module id = 1542
// module chunks = 124